export enum OperationsEnum {
  NOT = 'NOT',
  AND = 'AND',
  OR = 'OR',
  NAND = 'NAND',
  NOR = 'NOR'
}
